<aside class="cv-photo-sub-sketch">
  <diV class="cv-photo-sub-sketch__header">{{ structureType }}</diV>
  <div
    *ngFor="let level of levels; let even = even"
    [ngClass]="{
      'filled-columm': even
    }"
  >
    <div class="cv-photo-sub-sketch__levels">
      <label class="cv-photo-sub-sketch__text-level">
        Level {{ level.level }}</label
      >
      <ul class="cv-photo-sub-sketch__list" *ngFor="let item of level.info">
        <li class="cv-photo-sub-sketch__text-room">{{ item.room }}</li>
      </ul>
    </div>
  </div>
</aside>
